export default __webpack_public_path__ + "static/media/group-yd.767d4cb8.png";